<template>
    <div>
        <div v-for="(item , index) in regularData" :key="index">
            <div class="rule_li" v-if="item.countData.length != 0">
                <div class="title">{{item.title}}</div>
                <div :class="items == item.default?'rule_li_btn_s':'rule_li_btn'" @click="item.default = items" v-for="(items, indexs) of item.countData" :key="indexs">
                    {{items}}
                </div>
            </div>
        </div>

        <div v-for="(item , index) in extension" :key="index">
            <div class="rule_li" v-show="groupConfig(item)">
                <div class="title">{{item.title}}</div>
                <div v-for="(items, indexs) of item.names" :key="items">
                    <div @click="extensionClick(item , items , indexs)" :class="extensionClass(item , items , indexs)?'rule_li_btn_s':'rule_li_btn'">{{items}}</div>
                </div>
            </div>
        </div>

        <button @click="click()">dddddddd</button>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    data(){
        return{
            regularData:{},
            extension:[],
            componentKey:0,
            refresh:true,
            obj:{
                "iSets": [
                    2,
                    1,
                    8,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    13
                ],
                "bSets": [
                    0,
                    3,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                "gameID": "33100001"
            }
        }
    },
    components: {

    },
    created(){
        axios({
            method: 'get',
            url: 'https://mjdcdntest.17yp.com/mini/yueyouhui_apk/杭州配置.json',
        }).then(res=>{
            // console.log(res.data.lobby_setting)
            let data = res.data.lobby_setting
            // this.regularData = {
            //     user_count_title:{
            //         title:data.user_count_title,
            //         default:data.user_count_default,
            //         countData:data.user_count,
            //     },
            //     ju_count_title:{
            //         title:data.ju_count_title,
            //         countData:data.ju_count,
            //         default:''
            //     },
            // }
            // this.extension = data.extension
            this.regularData = {
                user_count_title:{
                    title:data.user_count_title,
                    default:this.obj.bSets[1],
                    countData:data.user_count,
                },
                ju_count_title:{
                    title:data.ju_count_title,
                    countData:data.ju_count,
                    default:this.obj.bSets[2]
                },
            }
            for(let item of data.extension){
                item.defaults = this.extensionEcho(item)
            }
            this.extension = data.extension
        })
    },
    methods:{
        extensionEcho(row){
            console.log(row)
            let defaults = []
            let num  = this.obj.iSets[row.group]
            console.log(num)
            row.names.forEach((item, index, arr) => {
                console.log(index+":"+item)
                if((num&1<<index) != 0){
                    defaults.push(index)
                }
            })
            return defaults
        },
        click(){
            // console.log(this.extension)
            let bSets = [0,0,0,0,0,0,0,0,0,0,]
            let iSets = []
            for(let item in this.extension.length){
                iSets.push(0)
            }
            for(let item of this.extension){
                if(item.type == "mutex"){
                    iSets[item.group] = 1<<item.defaults[0]
                }else {
                    let defaultNum = 0
                    for(let items of item.defaults){
                        defaultNum = defaultNum|1<<items
                    }
                    iSets[item.group] = defaultNum
                }
                // console.log(item)
            }
            for(let item in this.regularData){
                console.log(item)
                if(this.regularData[item].countData.length != 0){
                    if(item == 'user_count_title'){
                        bSets[1] = this.regularData[item].default
                    }else if (item == 'ju_count_title'){
                        bSets[2] = this.regularData[item].default
                    }
                }
            }
            console.log(bSets)
            console.log(iSets)
            console.log({
                iSets:iSets,
                bSets:bSets,
                "gameID": "33100001",
            })
        },
        // 显示隐藏逻辑处理
        groupConfig(item){
            if(!item.extra)return true
            if(!item.extra.includes('limit'))true
            let limitList = item.extra.split('|')
            let _list = []
            if(limitList[1] == 'group'){
                if(limitList.length%2 != 0){
                    return true
                }
                for(let i = 2;i < limitList.length; i++){
                    i++
                    _list.push({
                        group:Number(limitList[i-1]),
                        index:Number(limitList[i])
                    })
                }
                let _state = false
                if(limitList[0] == 'limitOrHide'){

                }else if(limitList[0] == 'limitAndHide'){

                }else if(limitList[0] == 'limitOrShow'){
                    _state = this.groupFlagOr(_list)
                }else if(limitList[0] == 'limitAndShow'){
                    
                }
                // console.log(_list)
                return _state
            }
        },
        groupFlagOr(_list){
            for(let item of this.extension){
                for(let items of _list){
                    // console.log(item.group == items.group && item.defaults.indexOf(items.index) == 0)
                    if(item.group == items.group && item.defaults.indexOf(items.index) == 0){
                        return true
                    }
                }
            }
            return false
        },
        // 选中状态逻辑处理
        extensionClass(data , items , indexs){
            let flag = false
            for(let item of data.defaults){
                // console.log(item)
                if(item == indexs){
                    flag = true
                }
            }
            return flag
        },
        // 动态规则点击事件
        extensionClick(item , items , indexs){
            console.log()
            if(item.type =='mutex'){
                console.log(item.defaults)
                item.defaults = [] 
                item.defaults = [indexs]
            }else{
                if(item.defaults.indexOf(indexs) == -1){
                    item.defaults.push(indexs)
                }else {
                    item.defaults = item.defaults.filter((value)=>{
                        return value != indexs
                    })
                }
            }
            // this.refresh = false
            // // 在组件移除后，重新渲染组件
            // // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
            // this.$nextTick(() => {
            //     this.refresh = true
            // })
        }
        
    }
}
</script>
<style scoped>
  .rule_li{
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eee;
    height: 60px;
  }
  .title{
    font-size: 18px;
    font-weight: bold;
    width: 160px;
    text-align: center;
  }
  .rule_li_btn{
    width: 100px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #ccc;
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    cursor: pointer;
  }
  .rule_li_btn_s{
    width: 100px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #8bf388;
    text-align: center;
    color: #8bf388;
    font-weight: bold;
    font-size: 18px;
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/views/demoView/demoJson.vue